import * as Type from './actionsTypes';
import { computeSubNsmpStatus, mergeNsmpForList } from '../../helpers/usoMutuoDigitacaoStatus';

const INITIAL_STATE = {
  nsmps: [],
  selected: {}
};

const ordenarPorNsmp = (a, b) => {
  if (isNaN(Number(a)) || isNaN(Number(b))) {
    const aSplit = a.codigo.split('_');
    const bSplit = b.codigo.split('_');

    if (aSplit.length > 1 && bSplit.length > 1 && aSplit[0] === bSplit[0]) {
      return Number(aSplit[1]) - Number(bSplit[1]);
    }

    return Number(aSplit[0]) - Number(bSplit[0]);
  }

  return Number(a) - Number(b);
} 

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Type.NSMPS_DELETE_SUCCESS:
    case Type.NSMPS_FIND_SUCCESS: {
      return {
        ...state,
        nsmps: action.data.sort(ordenarPorNsmp)
      };
    }
    case Type.NSMPS_FIND_BY_ID_SUCCESS: {
      return {
        ...state,
        selected: action.data
      };
    }
    case Type.NSMPS_CLONE_SUCCESS:
    case Type.NSMPS_SAVE_SUCCESS: {
      return {
        ...state,
        nsmps: [...state.nsmps, action.data].sort(ordenarPorNsmp),
        selected: {}
      };
    }
    case Type.NSMPS_DELETE_CLONE_SUCCESS: {
      const referenceIds = action.data.map(d => d.id);
      return {
        ...state,
        nsmps: [
          ...state.nsmps.filter(s => !referenceIds.includes(s.id) && s.id !== action.id), 
          ...action.data
        ].sort(ordenarPorNsmp),
        selected: {}
      };
    }
    case Type.NSMPS_UPDATE_SUCCESS:
    case Type.NSMPS_DIGITAR_SUCCESS: {
      const previousRow = state.nsmps.find(s => s.id === action.data.id);
      const mergedRow = mergeNsmpForList(previousRow, action.data);
      const selected = state.selected && state.selected.id === action.data.id
        ? mergedRow
        : state.selected;
      return {
        ...state,
        nsmps: [
          ...state.nsmps.filter(s => s.id !== action.data.id),
          mergedRow,
        ].sort(ordenarPorNsmp),
        selected,
      };
    }
    case Type.NSMPS_SUBNSMP_VALIDATE_SUCCESS: {
      const { subNsmpId, validateType } = action;
      const selectedSubs = state.selected && state.selected.subNsmps;
      if (!state.selected || !state.selected.id || !Array.isArray(selectedSubs)) {
        return state;
      }
      if (!selectedSubs.some(sub => sub.id === subNsmpId)) {
        return state;
      }

      const subNsmps = selectedSubs.map(sub =>
        sub.id === subNsmpId ? { ...sub, validate: validateType } : sub
      );
      const selected = { ...state.selected, subNsmps };
      const subNsmpStatus = computeSubNsmpStatus(subNsmps);

      return {
        ...state,
        selected,
        nsmps: state.nsmps.map(row =>
          row.id === selected.id ? { ...row, subNsmpStatus } : row
        ),
      };
    }
    case Type.NSMPS_PATCH_AUDITORIA_SUCCESS: {
      const patch = {
        auditoria: action.data.auditoria,
        auditoriaDescription: action.data.auditoriaDescription
      };
      const nsmps = state.nsmps.map(s =>
        s.id === action.data.id ? { ...s, ...patch } : s
      );
      const selected =
        state.selected && state.selected.id === action.data.id
          ? { ...state.selected, ...patch }
          : state.selected;
      return {
        ...state,
        nsmps: nsmps.sort(ordenarPorNsmp),
        selected
      };
    }
    case Type.NSMPS_CLEAN: {
      return INITIAL_STATE;
    }
    case Type.NSMPS_CLEAN_SELECTED: {
      return {
        ...state,
        selected: {}
      };
    }
    default:
      return state;
  }
}

export const getNsmps = state => state.rootState.nsmp.nsmps;
export const getNsmpSelected = state => state.rootState.nsmp.selected;
